import { useState } from 'react';
import { IconUserCheck } from '@iwoca/icons';
import { GetApiIntroducerPortalIntroducerReintroductionSearchResponse } from '@iwoca/lapi-client/introducer_portal';
import { Spinner } from '@iwoca/orion';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { InfoCard } from 'components/InfoCard/InfoCard';
import { HelpModal } from 'components/Navigation/Help/HelpModal';
import styles from './ReintroductionSearchStatus.module.css';

type TProps = {
  isFetching: boolean;
  data:
    | GetApiIntroducerPortalIntroducerReintroductionSearchResponse['data']
    | null;
};

export const ReintroductionSearchStatus = ({ isFetching, data }: TProps) => {
  const [showHelpModal, setShowHelpModal] = useState(false);
  if (!isFetching && !data) return null;

  return (
    <div className={styles.container}>
      {isFetching ? (
        <Spinner />
      ) : (
        <InfoCard
          icon={IconUserCheck}
          title="Good news - there’s a reintroduction opportunity!"
        >
          We’ve funded this customer before, so we’ve pre-filled some details
          from our records that cannot be edited. If anything needs updating,
          please{' '}
          <ButtonLink
            onClick={() => setShowHelpModal(true)}
            className={styles.contactButton}
            inline
          >
            contact us.
          </ButtonLink>
        </InfoCard>
      )}

      <HelpModal
        showModal={showHelpModal}
        closeModal={() => setShowHelpModal(false)}
      />
    </div>
  );
};
